import Regex from './Regex'

export default class Email extends Regex {
  get ruleName () {
    return 'email'
  }

  passes () {
    return super.passes(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
  }
}
